import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id F7F07C92-4531-466D-AC3E-F7822D2FDFBD
 * name tray-minus
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tray-minus.svg
 * tags
 */
export const TrayMinusIcon = createSvgIcon(<><path d="M16 10H8V8H16M2 17A2 2 0 0 0 4 19H20A2 2 0 0 0 22 17V12H20V17H4V12H2Z" /></>, 'TrayMinusIcon');
export default TrayMinusIcon